import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "personal-center-card__item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "personal-center-card__item--hd" }, "参赛队伍", -1)
const _hoisted_3 = {
  key: 0,
  class: "personal-center-card__item--bd"
}
const _hoisted_4 = {
  key: 1,
  class: "personal-center-card__item--bd2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-red-ba6242dbc265ace84ab27af62510b39c.png",
  alt: "",
  class: "card-item-icon"
}, null, -1)
const _hoisted_6 = { class: "card-item-text" }
const _hoisted_7 = {
  key: 2,
  class: "personal-center-card__item--bd2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-green-697b5ce1666305ad6fdf87081f45b0ae.png",
  alt: "",
  class: "card-item-icon"
}, null, -1)
const _hoisted_9 = { class: "card-item-text" }
const _hoisted_10 = {
  key: 3,
  class: "personal-center-card__item--bd2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-b8ce304f3116a02872d1bdb7e39d4713.png",
  alt: "",
  class: "card-item-icon"
}, null, -1)
const _hoisted_12 = { class: "card-item-text" }
const _hoisted_13 = {
  key: 0,
  class: "personal-center-card__copy"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "copy-hd" }, "队伍ID", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/id-tips-525bd9f00d8b7c8895f73d8d18834bc5.png",
  alt: "",
  class: "copy-statusIcon"
}, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "personal-center-card__member"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "member-hd" }, "队伍成员", -1)
const _hoisted_18 = { class: "member-con" }
const _hoisted_19 = { class: "member-bd" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/member-tx-abb7978949108dfdc463c1b21201c551.png",
  alt: "",
  class: "member-bd-img"
}, null, -1)
const _hoisted_21 = { class: "member-bd-txt" }
const _hoisted_22 = {
  key: 0,
  class: "member-bd-tag"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("创建队伍")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("加入队伍")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "personal-center-card__hdtitle" }, "队伍名称", -1)
const _hoisted_28 = { class: "card-ipt-box" }
const _hoisted_29 = { class: "wrong-txt" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("提交申请")
const _hoisted_31 = { class: "card-ipt-box" }
const _hoisted_32 = { class: "wrong-txt" }
const _hoisted_33 = { class: "personal-center-card__pipei" }
const _hoisted_34 = { class: "pipei-left" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "pipei-title" }, "匹配队伍：", -1)
const _hoisted_36 = { class: "pipei-desc" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("加入队伍")
const _hoisted_38 = { class: "personal-center-card__item personal-center-card__item--access" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "personal-center-card__item--hd" }, "参赛通道", -1)
const _hoisted_40 = { class: "personal-center-card__item--tongdao" }
const _hoisted_41 = { class: "personal-center-card__item--tips" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "personal-center-card__item--tips-line" }, " 每支队伍可以加入赛道数量不限，队伍中只允许队长选择赛道，队长选择后其他成员将同步赛道信息。 ", -1)
const _hoisted_43 = { class: "personal-center-card__item--tips-line" }
const _hoisted_44 = { class: "personal-center-card__item--tips-line" }
const _hoisted_45 = { class: "personal-center-card__item--entrance" }
const _hoisted_46 = { class: "entrance-item-hd" }
const _hoisted_47 = { class: "entrance-item-hd__text" }
const _hoisted_48 = {
  key: 0,
  class: "entrance-item-hd__text"
}
const _hoisted_49 = {
  key: 1,
  class: "entrance-item-hd__text t-succeed"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-green-697b5ce1666305ad6fdf87081f45b0ae.png",
  alt: "",
  class: ""
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "已加入", -1)
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "entrance-item-bd" }
const _hoisted_54 = { class: "entrance-item-ft" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 退出赛道 ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 加入赛道 ")
const _hoisted_57 = ["href"]
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 了解详情 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popover = _resolveComponent("Popover")!
  const _component_ClipBoard = _resolveComponent("ClipBoard")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.teamInfo?.Id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "可创建队伍成为队长，如果已有队伍可直接加入队伍"))
        : _createCommentVNode("", true),
      (_ctx.teamInfo?.AuditState == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, "你的队伍【" + _toDisplayString(_ctx.teamInfo?.Name) + "】因" + _toDisplayString(_ctx.teamInfo?.RejectReason || '敏感词汇') + "审核不通过，请重新创建/加入队伍", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.teamInfo?.AuditState == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, "你的队伍【" + _toDisplayString(_ctx.teamInfo?.Name) + "】已通过审核", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.teamInfo?.AuditState == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, "你的队伍【" + _toDisplayString(_ctx.teamInfo?.Name) + "】正在审核中，请耐心等待", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.teamInfo?.InviteNo && _ctx.isCaption)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_Popover, {
            placement: "top-start",
            trigger: "hover",
            content: "可分享给其它人，通过搜索队伍ID来加入队伍"
          }, {
            reference: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_ClipBoard, {
            copyContent: _ctx.teamInfo?.InviteNo
          }, null, 8, ["copyContent"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.teamMember.length && _ctx.teamInfo?.AuditState !== 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMember, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "member-line",
                key: item.Id
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.UserName), 1),
                  (item.Role === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "队长"))
                    : _createCommentVNode("", true),
                  (_ctx.raceInfo?.hasModify && _ctx.isCaption && item.Uin !== _ctx.userStatus?.Uin)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.deleteTeam(item.TeamId, '3', item.Id)),
                        src: "https://static.wecity.qq.com/miying/member-close-6789da389043ec8da4c8b53f6cc50d77.png",
                        alt: "",
                        class: "member-bd-close"
                      }, null, 8, _hoisted_23))
                    : _createCommentVNode("", true),
                  (_ctx.raceInfo?.hasModify && !_ctx.isCaption && item.Uin === _ctx.userStatus?.Uin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "member-bd-btn",
                        onClick: ($event: any) => (_ctx.deleteTeam(item.TeamId, '2', item.Id))
                      }, " 退出队伍 ", 8, _hoisted_24))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.raceInfo?.hasModify && _ctx.isCaption && _ctx.teamInfo?.Id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "member-bd-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTeam(_ctx.teamInfo.Id)))
              }, "解散队伍"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.raceInfo?.hasAdd && (!_ctx.teamMember.length || _ctx.teamInfo?.AuditState == 2))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_RadioGroup, {
            modelValue: _ctx.teamAction,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.teamAction) = $event)),
            class: "personal-center-card__radio"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Radio, { label: "createTeam" }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }),
              _createVNode(_component_Radio, { label: "addTeam" }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.teamAction === 'createTeam')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_27,
                _createElementVNode("div", {
                  class: _normalizeClass(["personal-center-card__ipt", _ctx.teamNameInput.errMessage || !_ctx.teamNameInput.value.length ? 'personal-center-card__ipt--redborder' : ''])
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Input, {
                      type: "text",
                      maxlength: "30",
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeValue('teamNameInput'))),
                      modelValue: _ctx.teamNameInput.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teamNameInput.value) = $event)),
                      placeholder: "请输入队伍名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.teamNameInput.errMessage), 1),
                  _createVNode(_component_Button, {
                    type: "primary",
                    disabled: !_ctx.teamNameInput.value.length,
                    onClick: _ctx.handleSaveArTeam,
                    class: "align-semi"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ], 2)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.teamAction === 'addTeam')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["personal-center-card__ipt", _ctx.teamNameSearch.errMessage || !_ctx.teamNameSearch.value.length ? 'personal-center-card__ipt--redborder' : ''])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Input, {
                      type: "text",
                      onKeyup: _withKeys(_ctx.searchTeam, ["enter"]),
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChangeValue('teamNameSearch'))),
                      modelValue: _ctx.teamNameSearch.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.teamNameSearch.value) = $event)),
                      maxlength: "32",
                      placeholder: "请输入邀请码，点击搜索加入"
                    }, null, 8, ["onKeyup", "modelValue"]),
                    _createElementVNode("img", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.searchTeam && _ctx.searchTeam(...args))),
                      src: "https://static.wecity.qq.com/miying/search-icon (2)-790a1c836ac9eb1897b5a6513d996884.png",
                      alt: "",
                      class: "card-ipt-searchIcon"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.teamNameSearch.errMessage), 1)
                ], 2),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.teamNameSearch.name), 1)
                  ]),
                  _createVNode(_component_Button, {
                    class: "pipei-right",
                    disabled: !_ctx.teamNameSearch.teamId,
                    onClick: _ctx.joinArUserComb
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_38, [
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, " 报名时间（" + _toDisplayString(_ctx.regEndTime) + "）结束之前，可以任意加入新的赛道，如果未加入任何赛道，将无法参加比赛。 ", 1),
          _createElementVNode("div", _hoisted_44, "初赛（" + _toDisplayString(_ctx.preStartTime) + "）开始之后，已加入的赛道无法再退出", 1)
        ]),
        _createElementVNode("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "entrance-item",
              key: item.Id
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.orderMap.get(index + 1)), 1),
                (!_ctx.ChannelsList.includes(item.Id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, "未加入"))
                  : _createCommentVNode("", true),
                (_ctx.ChannelsList.includes(item.Id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_52))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_53, _toDisplayString(item.Title), 1),
              _createElementVNode("div", _hoisted_54, [
                (_ctx.raceInfo?.hasAdd && _ctx.raceInfo?.hasModify && _ctx.isModifyChannel && _ctx.ChannelsList.includes(item.Id))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "danger",
                      onClick: ($event: any) => (_ctx.exitChannel(item, index)),
                      class: "t-red"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_55
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                ((_ctx.raceInfo?.hasAdd || _ctx.raceInfo?.hasModify) && _ctx.isModifyChannel && !_ctx.ChannelsList.includes(item.Id))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.addChannels(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_56
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  href: `./channelDetail?id=${item.Id}`,
                  target: "_blank"
                }, [
                  _createVNode(_component_Button, {
                    plain: "",
                    class: _normalizeClass((_ctx.raceInfo?.hasAdd || _ctx.raceInfo?.hasModify) && _ctx.isModifyChannel ? 't-default' : '')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_58
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 8, _hoisted_57)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}